import { useTopicAuto } from "@hooks/selectors/user/support.selectors";
import { FC } from "react";
import { Text } from '@components/constructor/components';

const SupportTopicLastAnswer: FC = (props) => {
    const topic = useTopicAuto();

    if (!topic) {
        return null;
    }

    return (
        <Text text={topic.lastAnswer} {...props} />
    )
}

export default SupportTopicLastAnswer;